import React, {useState} from "react";
import PlayScreen from "../../../../common/components/game-screens/PlayScreen";
import Button from "../../../../common/components/Button";
import T from "../../../../common/i18n/Text";

interface Props {
    showConfig: () => void;
    showInfo: () => void;
    lines: string[]
}

const LinesGamePlay = ({showConfig, showInfo, lines}: Props) => {
    const [lineIndex, changeLineIndex] = useState<number>(0);
    const nextBtnHandleClick = () => {changeLineIndex(lineIndex + 1);};

    const actionButton = <Button type="primary" onClick={nextBtnHandleClick} disabled={lineIndex >= (lines.length - 1)} name="lines-next">
        <T path="games.buttons.nextLine" />
    </Button>;

    const audienceLine = <div className="flex flex-row justify-center items-center">
        <span className="text-[50px]">{lines[lineIndex]}</span>
    </div>;

    return <PlayScreen mainActions={actionButton} showConfig={showConfig} showInfo={showInfo}>
        {audienceLine}
    </PlayScreen>;
};

export default LinesGamePlay;
